// extracted by mini-css-extract-plugin
export var container = "_mi-0";